const labels={capture:'전체 백업',archive:'외부 보관',restore:'복원 대조',replication:'실시간 복제',cutover:'서비스 전환',ha:'장애 복구',autoscale:'자동 확장'}
const states={pending:'대기',running:'진행 중',complete:'검증 완료',failed:'확인 필요',unknown:'미확인'}
const parts={'schema.dump':'스키마','application-data.dump':'채팅·공통','nodemaster-data.dump':'노드마스터','gantt-data.dump':'간트'}
const size=n=>Number.isFinite(n)?`${(n/1024**3).toFixed(2)} GiB`:'미확인'
export default function DatabaseMigration({data,stale,now}) {
  if(!data?.available)return <p className="sg-observed">DB 이전 진행 기록: {data?.reason==='not_registered'?'등록 대기':'조회 대기'}</p>
  const age=now-Date.parse(data.observedAt)
  const outdated=stale||data.stale||!Number.isFinite(age)||age>90000||age< -30000
  const active=data.steps.find(s=>s.status==='failed')||data.steps.find(s=>s.status==='running')||data.steps.find(s=>s.status==='pending')
  const complete=data.steps.filter(s=>s.status==='complete').length
  return <section className="sg-migration" aria-label="DB 이전 진행 상황">
    <div className="sg-migration-heading"><h3>DB 이전 진행 상황</h3><span className={`sg-signal ${!outdated&&complete===7?'is-good':''}`}>
      {outdated?'진행 기록 갱신 지연':active?`${labels[active.id]} · ${states[active.status]}`:'전체 단계 검증 완료'}</span></div>
    <p>{data.tableCount??'?'}개 테이블 · 저장된 백업 {size(data.capturedBytes)} · {outdated?'최신 상태 확인 필요':`${complete}/7단계 검증 완료`}</p>
    <ol className="sg-pipeline">{data.steps.map((step,index)=>{
      const status=outdated?'unknown':step.status
      return <li key={step.id} className={`is-${status}`}><span aria-hidden="true">{index+1}</span><strong>{labels[step.id]}</strong><small>{states[status]}</small></li>
    })}</ol>
    <details className="sg-backup-parts"><summary>백업 파일 {data.parts.filter(p=>p.completed).length}/4종 수집</summary>
      <ul>{data.parts.map(part=><li key={part.id}><span>{parts[part.id]}</span><span>{size(part.bytes)} · {outdated?'미확인':part.completed?'수집 완료':'수집 중'}</span></li>)}</ul>
    </details>
  </section>
}
